import { h, Component } from 'preact';
import styles from './multiple_choice_field_style';
import classNames from 'classnames';

export default class MultipleChoiceField extends Component {
  updateValue = (e) => {
    this.props.updateValue(e.target.value);
  }
  render({field,isValid,responses},{}) {
		var classes = classNames({
      'custom-select': true,
      'form-control': true,
      'is-invalid': !isValid
    });
		return (
      <select id={field.mapping} name={field.mapping} class={classes} onChange={this.updateValue}>
        <option selected>Choose an option</option>
        { field.options.map( option => (
          <option value={option.value}>{option.label}</option>
        )) }
      </select>
		);
	}
}
